import { layerRulesKeys } from '@components/EntityDrawers/constants/common';
import {
  CommonKeys,
  CoreRequiredKeys,
  LogicPhysicalKeys,
} from '@components/EntityDrawers/constants/keys';
import { LogicalFormValues } from '@components/EntityDrawers/drawers/Logical/form';
import {
  defaultValues,
  PhysicalFormValues,
  validationSchema,
} from '@components/EntityDrawers/drawers/Physical/form';
import { PhysicalKeys } from '@components/EntityDrawers/drawers/Physical/keys';
import { DrawerSettings } from '@components/EntityDrawers/hocs/withDrawer';
import { PhysicalSubLayerTypes } from '@constants/canvas/layers';
import { ProjectDrawerTypes } from '@constants/entities/drawers';
import { RefType } from '@constants/entities/project';
import { PhysicalMetaData } from '@store/services/nodes/types';
import {
  checkValuesIncomplete,
  prepareBasicLogicPhysicalData,
  transformCommonKeys,
  transformRulesFormValuesToMetaData,
  transformRulesToFormValues,
} from '@utils/drawers';

export const PhysicalSettings: DrawerSettings<
  PhysicalFormValues,
  PhysicalMetaData
> = {
  editType: ProjectDrawerTypes.EditPhysicalEntity,
  defaultValues,
  validationSchema,

  checkIncompleteFields: (values, projectSettings) =>
    checkValuesIncomplete<LogicalFormValues>(
      ...CoreRequiredKeys,
      CommonKeys.Description,
      CommonKeys.QnousRef,

      ...(projectSettings?.reference_model.includes(RefType.NIST)
        ? [CommonKeys.NistRef]
        : []),

      ...(projectSettings?.reference_model.includes(RefType.ISO)
        ? [CommonKeys.IsoRef]
        : []),

      ...(projectSettings?.reference_model.includes(RefType.ISM)
        ? [CommonKeys.IsmRef]
        : []),
    )(values),

  transformNodeDtoToFormValues: (nodeDto, context) => ({
    ...transformCommonKeys<PhysicalFormValues, PhysicalMetaData>(
      ...LogicPhysicalKeys,
    )(nodeDto, context),

    [layerRulesKeys[context.subLayer as PhysicalSubLayerTypes]]:
      transformRulesToFormValues(nodeDto.meta_data.rules),
  }),

  transformMetaDataToRequestBody: (metadata, { subLayer }) => {
    const rulesObject = {
      [PhysicalKeys.Standards]: metadata[PhysicalKeys.Standards],
      [PhysicalKeys.TechInstructions]: metadata[PhysicalKeys.TechInstructions],
    } as const;

    return {
      ...prepareBasicLogicPhysicalData(metadata),
      rules: transformRulesFormValuesToMetaData(
        rulesObject[layerRulesKeys[subLayer as PhysicalSubLayerTypes]] ?? [],
      ),
    } as PhysicalMetaData;
  },
};
